var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"collapse"}},[(_vm.visible)?_c('div',{staticClass:"root",class:_vm.rootClass},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconSrc}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.value))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }